import React, { useMemo, useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import AdminMaster from '../../Layout/admin/Master';
import { Toast, ToastContainer, OverlayTrigger, Modal, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useFormik } from 'formik';
import { BiReset, BiSearch } from 'react-icons/bi';
import { getUserlist, getUserManualAssign } from '../../Redux/qms/action';
import moment from 'moment';
import queueDatatableCustomStyles from '../../Layout/Elements/QueueDatatableCustomStyles';
import Select, { components, DropdownIndicatorProps } from 'react-select';
import { getAllClientDropdown } from '../../Redux/client/action';
import * as Yup from 'yup';
import 'rsuite/dist/rsuite.min.css';
import { HiChevronDown } from 'react-icons/hi';
import { TbGridDots } from 'react-icons/tb';
import { TextField, Tooltip } from '@mui/material';
import FacilityMultiSelectSelect from '../CommonComponent/FacilityMultiSelectSelect';
import { getProcessQueueData } from './Process';


const ProcessQueue = () => {

    const [datetime, setDateTime] = useState([]);
    const [state, setState] = useState({
        s_no: true,
        client: true,
        facility: true,
        lbx_file_name: true,
        lbx_file_count: true,
        total_file: true,
        index_file_amount: true,
        check_amount: true,
        balance: true,
        eft_amount: true,
        plb_amount: true,
        no_of_check: true,
        total_pages: true,
        status: true,
        internal_tat: true,
        lbx_file_size: true,
        file_received_on: true,
        output_generated_time: true,
        split_type: true,
        reason: true,
        actions: true,

    });

    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(100);
    const [limit, setLimit] = useState(100);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [data, setData] = useState([])
    const [colorRow, setColorRow] = React.useState({});


    const [clientName, setClientName] = useState("")
    const [selectValue, setSelectValue] = useState([])


    const [pageno, setPageNo] = useState(1);
    const [userlist, setUserlist] = useState();
    const [clientList, setClientList] = useState();

    const [settings, setSettings] = useState();
    const [toaster, setToaster] = useState(null);

    const [ToastMessage, setToastMessage] = useState({
        status: false,
        message: "",
        type: "",
    })
    const [filterState, setFilterState] = useState([{
        staff: [],
        client: [],
        facility: [],
        client_group: [],
    }])
    const [facilities, setFacilities] = useState([]);
    const [selectedFacility, setSelectedFacility] = useState([]);
    useEffect(() => {
        getUserlist(1)((response) => {
            setUserlist(response?.data?.results)
        });

        getAllClientDropdown()((response) => {

            setClientList(response?.data)
        })

    }, []);



    const handleOnMultySelectChange = async (selected, name) => {

        let selectedIds = [];
        selected.map((option) => {
            selectedIds.push(option.value)
        })

        queueformik.setValues({ ...queueformik.values, [name]: selectedIds });


        setFilterState({
            ...filterState,
            [name]: selected
        })
        name === 'facility' && setSelectedFacility(selected)
        if (name === 'client' && selected?.length === 0) {
            setSelectedFacility([])
            queueformik.setFieldValue("facility", [])
            setFacilities([])
        }

    }


    const [searchedData, setSearchedData] = useState({
        search: "",
        client: "",
        deposit_date_range: "",
        created_date: "",
        status: "",
        queue_type: "",
        jobid: "",
        lockbox: "",
    })
    const [reRenderDataTable, setRerenderDataTable] = useState(false)

    const handleResetDataTable = () => {
        setRerenderDataTable(true)
        setTimeout(() => {
            setRerenderDataTable(false)
        }, 200);
    }

    const fetchQueueListing = async (
        page = 1,
        limit = 100,
        search = "",
        client = [],
        created_date = "",
        status = [],
        facility = [],
        queue_type = "",
        jobid = '',
        lockbox = ''

    ) => {

        setLoading(true);

        const params = {
            page,
            limit,
            search,
            client: Array.isArray(client) ? client.join(',') : client,
            created_date,
            status: Array.isArray(status) ? status.join(',') : status,
            facility: Array.isArray(facility) ? facility.join(',') : facility,
            queue_type: queue_type,
            jobid,
            lockbox

        };

        const response = await getProcessQueueData(params)();

        if (response?.status) {
            console.log("API DATA:", response.data);
            setData(response.data);
            setTotalRows(response.count);

        } else {
            setData([]);
            setTotalRows(0);
            setToastMessage({
                status: true,
                message: response?.message || "Failed",
                type: "danger"
            });

        }

        setLoading(false);
    };

    const queueformik = useFormik({
        enableReinitialize: true,
        initialValues: {
            search: "",
            client: '',
            facility: "",
            deposit_date_range: [],
            created_date: "",
            status: "",
            queue_type: "",
            jobid: "",
            lockbox: "",

        },

        validationSchema: Yup.object({
            queue_type: Yup.string().required("Queue Type is required"),
        }),

        validateOnMount: true,
        onSubmit: (values) => {
            if (!values?.queue_type) return;

            fetchQueueListing(1, limit, values?.search, values?.client, values.created_date, values?.status, values?.facility, values?.queue_type, values?.jobid, values?.lockbox)
            setSearchedData({
                search: values?.search ? values?.search : "",
                client: values?.client ? values?.client : "",
                deposit_date_range: values?.deposit_date_range ? values?.deposit_date_range : "",
                created_date: values?.created_date ? values?.created_date : "",
                status: values?.status ? values?.status : "",
                queue_type: values?.queue_type ? values?.queue_type : "",
                facility: values?.facility ? values?.facility : "",
                jobid: values?.jobid ? values?.jobid : "",
                lockbox: values?.lockbox ? values?.lockbox : "",

            })
            handleResetDataTable()
        },

    });

    const getQueueColumnTitle = () => {
        const selected = searchedData?.queue_type;

        if (!selected) return "Queue Data";

        if (["Grid", "Snipping"].includes(selected)) return "Job ID";
        if (selected === "Output_Generation") return "Lockbox";
        if (selected === "File_Split") return "File Name";

        return "Queue Data";
    };


    const getQueueName = (row) => {
        const selected = searchedData?.queue_type;
        if (selected === "File_Split") return row.file_name;
        if (selected === "Output_Generation") return row.lockbox_name;
        if (["Grid", "Snipping"].includes(selected)) return row.job;

        if (row.job) return row.job;
        if (row.lockbox_name) return row.lockbox_name;
        if (row.file_name) return row.file_name;
        return "";
    };


    const columns = useMemo(() => [
        {
            name: "S NO",
            selector: (row, index) =>
                pageno === 1 ? index + 1 : (pageno - 1) * limit + index + 1,
            width: "80px",
        },
        {
            name: "Client",
            selector: row => row.client,
            sortable: true,
            width: "150px",
        },
        {
            name: "Facility",
            selector: row => row.facility,
            sortable: true,
            width: "180px",
        },
        {
            name: getQueueColumnTitle(),
            selector: row => getQueueName(row),
            cell: row => <span>{getQueueName(row)}</span>,
            sortable: true,
            width: "160px",
        },
        ...(["Grid", "Snipping"].includes(searchedData?.queue_type)
            ? [{
                name: "File Name",
                selector: row => row.file_name,
                sortable: true,
                width: "170px",
            }]
            : []
        ),

        ...(searchedData?.queue_type !== "Output_Generation"
            ? [{
                name: "Lockbox",
                selector: row => row.lockbox_name,
                sortable: true,
                width: "160px",
            }]
            : []
        ),
        {
            name: "Start Time",
            selector: row => row.start_time,
            width: "130px",
            cell: row =>
                row.start_time
                    ? moment(row.start_time).format("M/DD/YY, H:mm")
                    : "-",
        },
        {
            name: "Status",
            selector: row => row.status,
            sortable: true,
        },
    ], [pageno, limit, searchedData]);




    const handlePageChange = page => {
        setPageNo(page)
        let created_date = datetime

        fetchQueueListing(page, limit, searchedData?.search, searchedData?.client, searchedData?.created_date, searchedData?.status, searchedData?.facility, searchedData?.queue_type);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchQueueListing(1, newPerPage, searchedData?.search, searchedData?.client, searchedData?.created_date, searchedData?.status, searchedData?.facility, searchedData?.queue_type)
        setLimit(newPerPage)
        handleResetDataTable()

    };



    // Initial fetch removed - queue_type is required before making API call

    console.log("queueformik", queueformik);


    const handleRowSelected = React.useCallback(state => {
        var ids = [];
        state.selectedRows.map((row, index) => {
            ids.push(row.id);
        })
        setSelectedRows(ids);
    }, []);

    const conditionalRowStyles = [
        {
            when: row => colorRow?.id == row?.id,
            style: {
                backgroundColor: '#dbf4f5',
            },
        },
        {
            when: row => colorRow?.id != row?.id && data.indexOf(row) % 2 === 0,
            style: {
                backgroundColor: '#ffffff',
            },
        },
        {
            when: row => colorRow?.id != row?.id && data.indexOf(row) % 2 !== 0,
            style: {
                backgroundColor: '#f2f2f2',
            },
        },
    ];


    const handleRowCheckClick = (row) => {

        setColorRow(row)
    }

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>

                {queueformik.values[state]?.length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}



            </components.DropdownIndicator>
        );
    };

    const [isFocusedClient, setIsFocusedClient] = useState(false);
    const [isFocusedStatus, setIsFocusedStatus] = useState(false);

    const statusList = [
        { label: 'PENDING', value: 'PENDING' },
        { label: 'IN_PROGRESS', value: 'IN_PROGRESS' },
        { label: 'QUEUE', value: 'QUEUE' },

    ]
    const queueTypeList = [
        { label: 'GRID', value: 'Grid' },
        { label: 'FILE SPLIT LOG', value: 'File_Split' },
        { label: 'OUTPUT GENERATION', value: 'Output_Generation' },
        { label: 'SNIPPING', value: 'Snipping' },
    ]

    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} />

            <main id="main" className="main">

                <div className="pagetitle tab-fixed-header ">
                    <h1 id='page-title'>Process Queue</h1>
                </div>

                <ToastContainer className="p-3" position={"top-end"}>
                    <Toast bg={ToastMessage?.type} onClose={() => setToastMessage(
                        {
                            status: false,
                            message: "",
                            type: "",
                        }

                    )}
                        show={ToastMessage?.status} animation={true} delay={2000} autohide>
                        <Toast.Body ><span className='text-white'>{ToastMessage?.message}</span></Toast.Body>
                    </Toast>

                </ToastContainer>

                <section className="section mt-5">
                    <div className="row align-items-top py-2 gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card mb-5 mb-xl-8">
                                <Form onSubmit={queueformik.handleSubmit} onReset={() => {
                                    queueformik.resetForm()
                                }}>
                                    <div className='' >
                                        <div className="d-flex flex-row justify-content-start gap-2 align-items-center px-4 py-4 flex-wrap py-3">



                                            <div className='jobmonitor-select'>
                                                <Select
                                                    options={queueTypeList}
                                                    components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="queue_type" /> }}
                                                    className="select-search-client "
                                                    classNamePrefix="select"
                                                    placeholder="Select Queue Type"
                                                    menuPlacement="auto"
                                                    maxMenuHeight={300}
                                                    isClearable
                                                    name="queue_type"
                                                    onChange={(e) => {
                                                        queueformik.setFieldValue('queue_type', e?.value || '')
                                                    }}
                                                    value={queueTypeList.find(i => i.value === queueformik?.values?.queue_type) || null}
                                                    onFocus={() => setIsFocusedStatus(true)}
                                                    onBlur={() => {
                                                        setIsFocusedStatus(false)
                                                        queueformik.setFieldTouched("queue_type", true)
                                                    }}
                                                    styles={{

                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: !queueformik?.values?.queue_type ? "solid" : "none",
                                                            boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                            borderColor: queueformik?.errors?.queue_type ? 'red' : styles.borderColor,
                                                            "&:hover": {
                                                                border: `1px solid ${queueformik?.errors?.queue_type ? "red" : "#6ba2b6"}`
                                                            }
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),

                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusedStatus ? "auto" : "30px",
                                                        }),

                                                    }}
                                                />
                                            </div>


                                            <div className='jobmonitor-select'>
                                                <Select
                                                    isMulti
                                                    options={clientList}
                                                    components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="client" /> }}
                                                    className="select-search-client "
                                                    classNamePrefix="select"
                                                    placeholder="Select Client"
                                                    values={selectValue}
                                                    menuPlacement="auto"
                                                    maxMenuHeight={300}
                                                    isClearable
                                                    name="client"
                                                    onChange={(e) => handleOnMultySelectChange(e, 'client')}
                                                    defaultValue={queueformik?.values?.client}
                                                    onFocus={() => setIsFocusedClient(true)}
                                                    onBlur={() => setIsFocusedClient(false)}
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={false}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),

                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusedClient ? "auto" : "30px",
                                                        }),

                                                    }} />
                                            </div>



                                            {(['Grid', 'Snipping'].includes(queueformik.values.queue_type)) && (
                                                <div className="d-flex justify-content-center align-items-center p-2">

                                                    <TextField
                                                        id="jobid"
                                                        name="jobid"
                                                        type="search"
                                                        placeholder="Job ID"
                                                        value={queueformik?.values?.jobid}
                                                        onChange={(e) => {
                                                            queueformik.setValues({
                                                                ...queueformik.values,
                                                                jobid: e.target.value
                                                            });
                                                        }}
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true
                                                        }}
                                                        sx={{
                                                            width: "270px",
                                                            fontSize: "17px",
                                                            backgroundColor: "#f5f5f5",
                                                            borderRadius: "8px",
                                                            padding: "6px 12px",


                                                            '& .MuiInputBase-root:before': {
                                                                borderBottom: "none"
                                                            },
                                                            '& .MuiInputBase-root:after': {
                                                                borderBottom: "none"
                                                            },
                                                            '& input': {
                                                                padding: "6px"
                                                            }
                                                        }}
                                                    />

                                                </div>
                                            )}


                                            {(['Grid', 'Snipping'].includes(queueformik.values.queue_type)) && (
                                                <div className="d-flex justify-content-center align-items-center p-2">
                                                    <TextField
                                                        id="lockbox"
                                                        name="lockbox"
                                                        type="search"
                                                        placeholder="Lockbox"
                                                        value={queueformik?.values?.lockbox}
                                                        onChange={(e) => {
                                                            queueformik.setValues({
                                                                ...queueformik.values,
                                                                lockbox: e.target.value
                                                            });
                                                        }}
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true
                                                        }}
                                                        sx={{
                                                            width: "270px",
                                                            fontSize: "17px",
                                                            backgroundColor: "#f5f5f5",
                                                            borderRadius: "8px",
                                                            padding: "6px 12px",


                                                            '& .MuiInputBase-root:before': {
                                                                borderBottom: "none"
                                                            },
                                                            '& .MuiInputBase-root:after': {
                                                                borderBottom: "none"
                                                            },

                                                            '& input': {
                                                                padding: "6px"
                                                            }
                                                        }}
                                                    />

                                                </div>
                                            )}


                                            <div style={{ minWidth: "250px", maxWidth: "250px" }} className="d-flex p-2  align-items-center" >
                                                <FacilityMultiSelectSelect setFacilities={setFacilities} options={facilities} clients={queueformik?.values?.client} facility={selectedFacility} setSelectedFacility={setSelectedFacility} handleChange={handleOnMultySelectChange} formik={queueformik} />
                                            </div>

                                            {/* <Tooltip disableInteractive title="Created Date" placement='top' arrow>

                                                <div className='' >
                                                    <Stack direction="column" spacing={8} alignItems="flex-start">

                                                        <DateRangePicker
                                                            ranges={predefinedBottomRanges}
                                                            // style={{ backgroundColor: "#000" }}
                                                            cleanable={true}
                                                            placement='auto'
                                                            appearance="default"
                                                            format={"MM/dd/yyyy"}
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            className="form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker"
                                                            name="deposit_date_range"
                                                            onChange={(e) => { handleOnDateTimeChange({ name: 'deposit_date_range', value: e }) }} value={queueformik?.values?.deposit_date_range} />

                                                    </Stack>
                                                </div>
                                            </Tooltip> */}

                                            <div className='jobmonitor-select'>
                                                <Select
                                                    options={statusList}
                                                    components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="status" /> }}
                                                    className="select-search-client "
                                                    classNamePrefix="select"
                                                    placeholder="Status"
                                                    menuPlacement="auto"
                                                    maxMenuHeight={300}
                                                    isClearable
                                                    name="status"
                                                    onChange={(e) => {
                                                        queueformik.setValues({
                                                            ...queueformik.values,
                                                            status: e?.value || ""
                                                        })
                                                    }}
                                                    value={statusList.find(i => i.value === queueformik?.values?.status)}
                                                    onFocus={() => setIsFocusedStatus(true)}
                                                    onBlur={() => setIsFocusedStatus(false)}
                                                    tabSelectsValue={false}
                                                    closeMenuOnSelect={true}
                                                    styles={{
                                                        container: (styles, state) => ({
                                                            ...styles,
                                                            borderRadius: "9px",
                                                        }),
                                                        placeholder: styles => ({
                                                            ...styles,
                                                            fontSize: '17px'
                                                        }),
                                                        control: (styles, state) => ({
                                                            ...styles,
                                                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                            borderStyle: "none", boxShadow: "none",
                                                            borderRadius: "10px",
                                                            maxHeight: state.isFocused ? "auto" : "30px",
                                                        }),
                                                        indicatorSeparator: styles => ({
                                                            ...styles, width: "0px",
                                                            minHeight: "20px"
                                                        }),

                                                        valueContainer: (styles, state) => ({
                                                            ...styles,
                                                            maxHeight: isFocusedStatus ? "auto" : "30px",
                                                        }),

                                                    }}
                                                />
                                            </div>


                                            <div className='' style={{ width: '' }}>
                                                <div className='d-flex justify-content-start gap-2'>
                                                    <Tooltip disableInteractive title="Search" placement='top' arrow>
                                                        <Button className="btn btn-light btn-active-primary  " type="submit">
                                                            <span className="svg-icon svg-icon-3">
                                                                <BiSearch />
                                                            </span>

                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip disableInteractive title="Reset" placement='top' arrow>
                                                        <Button className="btn btn-light btn-active-primary " type='reset' >
                                                            <span className="svg-icon svg-icon-3">
                                                                <BiReset />
                                                            </span>

                                                        </Button>
                                                    </Tooltip>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </Form>
                                <div className="card-body" style={{ padding: "0px 2.25rem" }}>
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            {!reRenderDataTable &&
                                                <DataTable
                                                    className="custom-datatable"
                                                    fixedHeader={true}

                                                    data={data}
                                                    columns={columns}
                                                    progressPending={loading}
                                                    pagination
                                                    paginationServer
                                                    onSelectedRowsChange={handleRowSelected}
                                                    paginationTotalRows={totalRows}
                                                    paginationPerPage={limit}
                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    conditionalRowStyles={conditionalRowStyles}
                                                    onRowClicked={handleRowCheckClick}
                                                    theme="solarized"
                                                    pointerOnHover
                                                    customStyles={queueDatatableCustomStyles}
                                                    responsive={true}
                                                // onSort={handleSort}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>

        </React.Fragment>
    )
}

export default ProcessQueue;